import Header from "./header/Header";
import { useNavigate } from "react-router-dom";
import ListPart from "./listpart/ListPart";
import LinkPart from "./linkpart/LinkPart";
import Footer from "./footer/Footer";
import SectionContextProvider from "../contexts/sectionContext";
import { useAuthStateContext } from "/src/features/auth/context/authContext";
import { hasAnyPermission } from "/src/utils/hasPermission";
import "./Sidebar.css";
import storage from "/src/utils/storage";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import checkPelletByTime from "/src/utils/checkPelletByTime"
//import useCompany from "/src/hooks/useCompany";

function SideBar() {
    // needed to reload sidebar
    useAuthStateContext();
    const navigate = useNavigate();
    const currentUser = storage("local").get("user");
    const isAdmin = !!currentUser?.is_admin;

    const sidebarRefEvents = (el) => {
        if (!el) {
            return;
        }
        el.addEventListener("mouseenter", () => (el.className = "sidebar visible transition"));
        el.addEventListener("mouseleave", () => (el.className = "sidebar reduced transition"));
    };

    //useCompany(user.company_id);

    return (
        <div id="sidebar-container">
            <div id="sidebar" className="sidebar reduced transition" ref={sidebarRefEvents}>
                <Header />
                <div id="container">
                    <SectionContextProvider>
                        {hasAnyPermission(['view_dashboards']) && <LinkPart onClick={()=> navigate("/supervision/dashboards")} name="operational dashboard" />}
                        {hasAnyPermission(['view_conversations', 'view_own_conversations']) && <LinkPart onClick={()=> navigate("/supervision/conversations/list")} name="conversation" plural={true} />}
                        {hasAnyPermission(['view_agents_performance']) && <LinkPart onClick={()=> navigate("/supervision/agents-performance")} name="agent performance"/>}
                        {hasAnyPermission(['view_agents_dashboard']) && <LinkPart onClick={()=> navigate("/supervision/dashboard/agents")} name="compliance performance dashboard" />}
                        <LinkPart onClick={()=> navigate("/supervision/call-evaluation")} name="call evaluation" />
                        {hasAnyPermission(['view_ia']) && <LinkPart onClick={()=> navigate("/ai/prompts")} name="ai" label="AI" plural={false} />}
                        {hasAnyPermission(['view_users']) && <LinkPart onClick={()=> navigate("/administration/users")} name="user" plural={true} />}
                        {(isAdmin || hasAnyPermission(['view_criteria', 'view_units', 'view_roles'])) && <LinkPart onClick={()=> navigate("/administration/configuration")} name="criteria" label="Configuration panel" plural={false} />}
                        {isAdmin && <LinkPart onClick={()=> navigate("/administration/activity-logs")} name="admin" label="Activity logs" plural={false} />}

                    </SectionContextProvider>

                </div>
                <Footer />
            </div>
        </div>
    );
}

export default SideBar;
